import type { IInputQuestion } from './_question';
import type { IDateInputProps } from '../Inputs/DateInput';

import React from 'react';
import { Controller } from 'react-hook-form';
import * as yup from 'yup';

import DateInput from '../Inputs/DateInput';

import InputWrapper from './elements/InputWrapper';
import Subtitle from './elements/Subtitle';
import Title from './elements/Title';

import getControlError from '$/hooks/getControlError';
import isDateValid from '$/utils/isDateValid';

export const yupDateInputQuestion = yup.date().transform((date) => {
  return date;
});

interface IDateInputQuestion
  extends IInputQuestion,
    Omit<IDateInputProps, 'selected' | 'onChange' | 'value'> {
  onValueSelected?: () => void;
}

const DateInputQuestion = ({
  control,
  name,
  onValueSelected,
  title,
  subTitle,
  setError,
  ...props
}: IDateInputQuestion) => (
  <InputWrapper>
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field, fieldState }) => {
        const error = getControlError(control, name, props.errorMessage);
        const onChange = (data: Date) => {
          if (isNaN(data.getTime()) && setError) {
            setError(name, { message: 'Falsches Datum' });
          }
          if (isDateValid(data)) {
            field.onChange(data);
            if (onValueSelected) {
              onValueSelected();
            }
          }
        };

        return (
          <>
            {title && <Title>{title}</Title>}
            {subTitle && <Subtitle>{subTitle}</Subtitle>}
            <DateInput
              {...field}
              {...fieldState}
              error={fieldState.invalid}
              onChange={onChange}
              {...props}
              errorMessage={error.message}
            />
          </>
        );
      }}
    />
  </InputWrapper>
);

export default DateInputQuestion;
